import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function Temperature({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Temperature</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {sensor_id || d.sensor_id} - {formatTimestamp(d.timestamp)}:
          <p style={{ marginLeft: '1em' }}>
            Temperature: {formatValue(d.temperature, 0)} °C
          </p>
        </div>
      ))}
    </Item>
  );
}
